import React, { useState } from 'react';
import { toast } from 'bulma-toast';
import PropTypes from 'prop-types';
import CommentCard from '../../../molecules/comments/comment-card/index.tsx';
import Heading from '../../../atoms/heading';
import TextAreaContainer from '../../../molecules/textarea-container';

const CreateCommentForm = function CreateCommentForm(props) {
    const { targetkey, baseurl } = props;
    const { host, protocol } = new URL(baseurl);

    const [comment, setComment] = useState();

    // FormValues
    const [amount, setAmount] = useState(0);
    const [author, setAuthor] = useState('');
    const [messageText, setMessageText] = useState('');
    const [parent, setParent] = useState('');

    const toastConfig = {
        position: 'bottom-center',
        duration: 2000,
        closeOnClick: true,
        pauseOnHover: true,
    };

    function sendApiRequest(body) {
        fetch(
            `${protocol}//${host}/odata/messages`,
            {
                method: 'POST',
                body: JSON.stringify(body),
                headers: new Headers({ 'content-type': 'application/json' }),
            },
        )
            .then((response) => {
                if (response.status === 201) {
                    toast({
                        ...toastConfig,
                        message: 'The Message has been created',
                        type: 'is-primary',
                    });
                } else {
                    toast({
                        ...toastConfig,
                        message: 'The Message could not be created',
                        type: 'is-danger',
                    });
                }

                return response.json();
            })
            .then((value) => {
                if (value.Key) {
                    setComment(value);
                }
            });
    }

    function onFormSubmit(e) {
        e.preventDefault();

        const formData = {
            Amount: parseFloat(amount),
            Author: author,
            MessageText: messageText,
            Parent: parent,
            TargetKey: targetkey,
        };

        sendApiRequest(formData);
    }

    const card = comment
        ? (
            <CommentCard
                key={comment.Key}
                author={comment.Author}
                messagetext={comment.MessageText}
                created={comment.Created}
                amount={comment.Amount}
                organization={comment.TargetKey}
            />
        )
        : null;

    const form = (
        <form onSubmit={onFormSubmit}>
            <label htmlFor="Amount">
                Amount
                <input className="input" type="number" name="Amount" onInput={(e) => setAmount(e.target.value)} />
            </label>

            <label htmlFor="Author">
                Author
                <input className="input" type="text" name="Author" onInput={(e) => setAuthor(e.target.value)} />
            </label>

            <label htmlFor="MessageText">
                MessageText
                <TextAreaContainer
                    maxcount={70}
                    displaycounter
                    placeholder="Enter a comment.Please limit this to 70 characters."
                    onInput={(e) => setMessageText(e.target.value)}
                >
                    <input type="text" name="MessageText" defaultValue="" />
                </TextAreaContainer>
            </label>

            <label htmlFor="Parent">
                Parent
                <input className="input" type="text" name="Parent" onInput={(e) => setParent(e.target.value)} />
            </label>

            <input className="button is-primary" type="submit" style={{ margin: 20, marginLeft: 0 }} />
        </form>
    );

    return (
        <div style={{ width: '50%' }}>
            <Heading>Create Comment Form</Heading>
            {form}
            {card}
            <br />
            <p>{JSON.stringify(comment)}</p>
        </div>
    );
};

CreateCommentForm.propTypes = {
    targetkey: PropTypes.string.isRequired,
    baseurl: PropTypes.string,
};

CreateCommentForm.defaultProps = {
    baseurl: window.location.href,
};

export default CreateCommentForm;
